/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import { NavigationGuardNext, Route, RouteConfig } from 'vue-router';
import { checkPermissions } from '@/router/routeValidation';
import { remotePaymentPermission } from './permissions';
import { NAVBAR_TYPE_LIGHT } from '@/util/constants/config';
import { ROUTES } from './routes';

const { REMOTE_PAYMENT_HOME, } = ROUTES;

const RemotePaymentHome = () =>
  import(
    /* webpackChunkName: "RemotePaymentHome" */
    '@/views/RemotePayment/RemotePaymentHome.vue'
  );

const transactionHistoryRoute: RouteConfig = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: REMOTE_PAYMENT_HOME.route,
      name: REMOTE_PAYMENT_HOME.name,
      component: RemotePaymentHome,
      beforeEnter(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
        checkPermissions(to, from, next);
      },
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
        permissions: remotePaymentPermission,
      },
    }
  ],
};
export default transactionHistoryRoute;
